// -------------------------------------------------------------
// META ADS MARKETING API INTEGRATION HELPER
// -------------------------------------------------------------

export const fetchMetaAdsCampaigns = async (actAccountId, accessToken) => {
  const cleanActId = actAccountId.startsWith('act_') ? actAccountId : `act_${actAccountId}`;
  
  if (!accessToken) {
    // Return simulated live fetch matching Meta Ads Manager screenshot
    return [
      {
        id: 'meta_c3',
        name: 'Prospek Web 06/08/2026',
        setIklan: 'Set Iklan Prospek Web',
        channel: 'Meta Ads (FB/IG)',
        status: 'Aktif',
        budget: 50000,
        reach: 0,
        impressions: 0,
        frequency: '0.00',
        results: 0,
        spent: 0,
        cpr: 0,
        cpc: 0,
        cpm: 0,
        ctr: '0.00%'
      }
    ];
  }

  try {
    const url = `https://graph.facebook.com/v19.0/${cleanActId}/campaigns?fields=id,name,status,daily_budget,insights{spend,impressions,reach,frequency,cpc,cpm,ctr,actions,cost_per_action_type}&access_token=${accessToken}`;
    const response = await fetch(url);
    const data = await response.json();

    if (data.error) {
      throw new Error(data.error.message);
    }

    if (Array.isArray(data.data)) {
      return data.data.map(item => {
        const insights = item.insights?.data?.[0] || {};
        return {
          id: item.id,
          name: item.name,
          setIklan: 'Set Iklan Meta',
          channel: 'Meta Ads (FB/IG)',
          status: item.status === 'ACTIVE' ? 'Aktif' : 'Pause',
          budget: item.daily_budget ? Number(item.daily_budget) / 100 : 50000,
          spent: insights.spend ? Number(insights.spend) : 0,
          reach: insights.reach ? Number(insights.reach) : 0,
          impressions: insights.impressions ? Number(insights.impressions) : 0,
          frequency: insights.frequency ? Number(insights.frequency).toFixed(2) : '0.00',
          results: insights.actions?.[0]?.value || 0,
          cpr: insights.cost_per_action_type?.[0]?.value ? Math.round(Number(insights.cost_per_action_type[0].value)) : 0,
          cpc: insights.cpc ? Math.round(Number(insights.cpc)) : 0,
          cpm: insights.cpm ? Math.round(Number(insights.cpm)) : 0,
          ctr: insights.ctr ? `${Number(insights.ctr).toFixed(2)}%` : '0.00%'
        };
      });
    }
  } catch (err) {
    console.error('Meta Ads API Fetch Error:', err);
    throw err;
  }

  return [];
};
